import IconBase, { type IconProps } from '@yoweb/ui/components/Icon/IconBase';

export const LockIcon = (props: IconProps) => (
  <IconBase viewBox="0 0 13 15" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8002 5.2H10.5002V3.9C10.5002 1.755 8.7452 0 6.6002 0C4.4552 0 2.7002 1.755 2.7002 3.9V5.2H1.4002C1.0752 5.2 0.750196 5.525 0.750196 5.85L0.75 13.65C0.75 14.04 1.01 14.3 1.4 14.3H11.8C12.19 14.3 12.45 14.04 12.45 13.65L12.4502 5.85C12.4502 5.525 12.1252 5.2 11.8002 5.2ZM4.0002 3.9C4.0002 2.47 5.1702 1.3 6.6002 1.3C8.0302 1.3 9.2002 2.47 9.2002 3.9V5.2H4.0002V3.9ZM11.15 13H2.05L2.0502 6.5H11.1502L11.15 13Z"
      fill="currentColor"
    />
  </IconBase>
);

export default LockIcon;
